import moment from 'moment';
const modals = {
  showData: {
    //用户选择的数据非单一的不放在查询参数里面
    deadlineDate: '', //截止时间
    placeOrderTime: [moment().subtract(29, 'days').startOf('days'), moment().endOf('days')], //订货时间
    readFlagData: '', //阅读状态
    orderModes: '', //出单方式
    shopList: '', //要货地点
  },

  orderNoticeAlreadyCount: null, //已发货数量
  orderNoticeCompleteCount: null, //已完成数量
  orderNoticeTodoCount: null, //待发货数量
  orderNoticeUndoCount: null, //已取消数量
  orderNoticeList: null, //table数据
  orderNoticeCurrent: null, //
  orderNoticeSize: null, //
  orderNoticeTotal: null, //
  exportLoading: false, // 导出loading
  orderNoticeId: null, //当前选择的id

  orderAcceptSerchParameters: {
    //查询参数
    receiveTimeBegin: moment().subtract(29, 'days').startOf('days').format('YYYY-MM-DD'),
    receiveTimeEnd: moment().endOf('days').format('YYYY-MM-DD'),
    pageNum: 1,
    pageSize: 10,
  },
};

export default modals;
